import { render, staticRenderFns } from "./Preventive-Detail.vue?vue&type=template&id=5c474f0c"
import script from "./Preventive-Detail.vue?vue&type=script&lang=js"
export * from "./Preventive-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports